import { z } from 'zod';

// Contrato de la bitácora de auditoría validado con Zod (ENG-VAL-01): un drift del
// backend (campo faltante, tipo inesperado) cae al estado de error de la query en
// vez de reventar en render. El endpoint devuelve filas crudas de audit_logs con
// los BigInt serializados a string por el reply serializer global de la API.

/** Fila de la bitácora. `category`/`action` quedan como string (no enum cerrado):
 *  una categoría/acción nueva del backend se muestra, no se oculta ni rompe. */
export const auditLogRowSchema = z.object({
  id: z.string(),
  occurredAt: z.string(),
  category: z.string(),
  action: z.string(),
  // Acción y cambio en palabras: los pone el API, única fuente (UX-COPY-01).
  actionLabel: z.string().default('Evento registrado'),
  beforeLabel: z.string().nullable().default(null),
  afterLabel: z.string().nullable().default(null),
  severity: z.string(),
  actorType: z.string(),
  actorDisplayName: z.string().nullable().optional(),
  actorEmail: z.string().nullable().optional(),
  actorAuthSubject: z.string().nullable().optional(),
  actorRole: z.string().nullable().optional(),
  targetModule: z.string().nullable().optional(),
  targetCode: z.string().nullable().optional(),
  targetId: z.string().nullable().optional(),
  beforeJson: z.unknown().optional(),
  afterJson: z.unknown().optional(),
  ip: z.string().nullable().optional(),
  outcome: z.string(),
  activeCompanyId: z.string().nullable().optional(),
  // Carga histórica (G1-2): fecha real del evento, aparte de la de registro.
  eventDate: z.string().nullable().optional(),
  loadedHistorically: z.boolean().optional(),
  // `eventDatePrecision: 'day'` = la carga solo traía el día (sin hora).
  metadata: z.record(z.string(), z.unknown()).nullable().optional(),
});

export const auditLogsResponseSchema = z.object({
  success: z.literal(true),
  data: z.array(auditLogRowSchema),
  meta: z.object({
    next_cursor: z.string().nullable(),
    page_size: z.number(),
  }),
});

export const auditSummarySchema = z.object({
  today: z.number(),
  month: z.number(),
  signaturesMonth: z.number(),
  returnsMonth: z.number(),
});

export const auditSummaryResponseSchema = z.object({
  success: z.literal(true),
  data: auditSummarySchema,
});

export type AuditLogRow = z.infer<typeof auditLogRowSchema>;
export type AuditLogsResponse = z.infer<typeof auditLogsResponseSchema>;
export type AuditSummary = z.infer<typeof auditSummarySchema>;
